<h2>{{ "clients.clients" | transloco }}</h2>

<header>
  <div class="tax-year" id="year">
    @if (taxYears) {
    <app-search-dropdown
      label="{{ yearLabel }}"
      [formGroup]="searchForm"
      [formCtrl]="taxYear"
      [listOptions]="taxYears"
    ></app-search-dropdown>
    }
  </div>

  <div id="filters">
    <div class="ui left icon input">
      <i class="search icon"></i>
      <input
        [attr.data-test-ref]="'clients-search'"
        type="text"
        [(ngModel)]="clientSearch"
        placeholder="{{ 'clients.search-clients' | transloco }}"
      />
    </div>
  </div>

  @if (userInfo.isClientAdmin) {
  <div [attr.data-test-ref]="'create-new'">
    <div
      class="ui primary button"
      [attr.data-test-ref]="'new-client-button'"
      (click)="openClientModal()"
    >
      {{ "clients.new-client" | transloco }}
    </div>
    @if (showUploadList) {
    <span>
      @if (isUploading) {
      <div class="ui basic blue loading button">
        {{ "clients.upload-list" | transloco }}wwwwwww
      </div>
      } @if (!isUploading) {
      <input
        type="file"
        id="list-upload-btn"
        (click)="$event.target.value = null"
        (change)="preStartBulkUpload($event.target.files)"
      />
      }
    </span>
    }
  </div>
  }
</header>

@if (loading) {
<div class="loading">
  <div class="ui active centered inline loader"></div>
</div>
} @if (clients?.length == 0 || (clients|keyWord:['name']:clientSearch)?.length
== 0) {
<div [attr.data-test-ref]="'no-results'">
  {{ "clients.no-clients-found" | transloco }}
</div>
} @if (clients?.length > 0) {
<table id="list" width="100%" cellspacing="0">
  @for (client of clients|keyWord:['name']:clientSearch; track client) { @if
  (!(client.status === 99 && client.populationCount === 1)) {
  <tr
    [routerLink]="[client?.id, 'populations']"
    [queryParams]="{ taxYear: taxYear?.value?.value }"
  >
    <td class="client-name">
      <strong>{{ client?.name }}</strong>
    </td>
    <td class="client-populations" *transloco="let t">
      {{ client?.populationCount }}
      {{
        client?.populationCount === 1
          ? t("clients.population")
          : t("clients.populations")
      }}
    </td>
    <td class="client-assignees" *transloco="let t">
      {{ client?.assigneeCount }} {{ taxpayerAlias
      }}{{ client?.assigneeCount === 1 ? "" : t("clients.s") }}
    </td>
    <td>
      {{ getPopulationCountryCode(client?.countryId) }}
    </td>
    <td class="client-view btn">
      <strong>{{ "clients.view" | transloco }}</strong>
    </td>
  </tr>
  } }
</table>

} @if (userInfo.isClientAdmin) {
<div
  #newClientModal
  [attr.data-test-ref]="'new-client-modal'"
  id="new-client-modal"
  class="ui tiny modal"
>
  <div class="icon modal-close close"></div>
  <h1>{{ "clients.add-a-new-client" | transloco }}</h1>
  <form (ngSubmit)="saveNewClient()">
    <div class="content">
      <label>{{ "clients.client-name-text" | transloco }}</label>
      <input
        [attr.data-test-ref]="'client-name-input'"
        type="text"
        [formControl]="clientNameInput"
        [(ngModel)]="clientName"
      />
      @if (config.featureFlags.clientDigitalGatewayIdentifier) {
      <label>Client Digital Gateway Identifier</label>
      } @if (config.featureFlags.clientDigitalGatewayIdentifier) {
      <input
        [attr.data-test-ref]="'client-digital-gateway-identifier-input'"
        type="number"
        min="0"
        max="1999999999"
        [formControl]="clientDigitalGatewayIdentifierInput"
        [(ngModel)]="clientDigitalGatewayIdentifier"
      />
      } @if (!validateDigitalGatewayIdentifier()) {
      <div id="notValidDGI" class="error-message">
        {{ validateDGIText }}
      </div>
      }
    </div>
    @if (config.featureFlags.onlyAllowSingleCountryPerClient) {
    <div [hidden]="!showCountries" class="content">
      <label>{{ 'clients.country' | transloco: {countryAlias} }}</label>
      <div class="ui search selection dropdown" #countryDropDown>
        <i class="chevron down icon"></i>
        <div class="text"></div>
        <div class="menu"></div>
      </div>
      <input type="hidden" [(ngModel)]="newClientCountryId" name="countryId" />
    </div>
    }
    <div class="actions">
      <span
        [attr.data-test-ref]="'client-name-cancel'"
        class="go-back cancel"
        >{{ "clients.cancel" | transloco }}</span
      >
      <button
        [attr.data-test-ref]="'client-name-create'"
        class="ui primary background button"
        [ngClass]="{
          disabled:
            !clientName ||
            (config.featureFlags.onlyAllowSingleCountryPerClient &&
              !newClientCountryId)
        }"
      >
        {{ "clients.create" | transloco }}
      </button>
    </div>
  </form>
</div>
} @if (userInfo.isClientAdmin) {
<div #successModal [attr.data-test-ref]="'success-modal'" class="ui tiny modal">
  <div class="icon modal-close close"></div>
  <div class="content">
    <div class="icon green-success"></div>
    <h3>
      {{ "clients.new-client" | transloco }} <strong>{{ clientName }}</strong>
      {{ "clients.created-successfully" | transloco }}
    </h3>
  </div>
  <div class="actions">
    <div
      [attr.data-test-ref]="'client-created-successfully-okay'"
      class="ui primary background button approve"
    >
      {{ "clients.ok" | transloco }}
    </div>
  </div>
</div>
}

<div
  #taxpayersAuthListPreUpload
  id="taxpayers-preupload-modal"
  class="ui modal"
>
  <div class="icon modal-close close"></div>

  <h1>{{ "clients.upload-list" | transloco }}vvvvv</h1>

  <div class="content">
    <p class="subheading">
      {{ "clients.file-to-upload" | transloco }}
      <strong>{{ authListForUploadFile?.name }}</strong>
    </p>
    <form
      [formGroup]="authListUploadForm"
      (ngSubmit)="bulkUpload()"
      class="ui form"
    >
      <div class="field">
        @if (taxReturnTypeOptions) {
        <app-search-dropdown
          label="{{ taxReturnAlias }} Type"
          [formGroup]="authListUploadForm"
          [formCtrl]="taxReturnTypeCtrl"
          [listOptions]="taxReturnTypeOptions"
        ></app-search-dropdown>
        }
      </div>
      <div class="field subtypes">
        @if (taxReturnSubTypeOptions) {
        <app-search-dropdown
          label="{{ taxReturnAlias }} Subtype"
          [formGroup]="authListUploadForm"
          [formCtrl]="taxReturnSubTypeCtrl"
          [listOptions]="taxReturnSubTypeOptions"
        ></app-search-dropdown>
        }
      </div>
    </form>
  </div>

  <div class="actions">
    <span class="go-back cancel">{{ "clients.cancel" | transloco }}</span>
    <div
      class="ui primary background button approve"
      [ngClass]="{ disabled: !authListUploadForm.valid }"
    >
      {{ "clients.upload-list" | transloco }}
    </div>
  </div>
</div>

<div
  #taxpayersUpload
  id="taxpayers-upload-modal"
  class="ui modal"
  [ngClass]="{ tiny: !hasResults }"
>
  <div class="icon modal-close close"></div>
  <div
    class="icon"
    [ngClass]="{
      'green-success': !bulkAddAssignee?.error,
      'red-error': bulkAddAssignee?.error
    }"
  ></div>

  @if (hasResults) {
  <h2 transloco="let t;">
    {{ "clients.upload" | transloco }}
    {{ partialSuccessUpload ? t("clients.partially") : undefined }}
    {{ "clients.successful" | transloco }}
  </h2>
  } @if (!hasResults && bulkAddAssignee?.error) {
  <h2>{{ "clients.error-with-csv-upload" | transloco }}</h2>
  }

  <div class="content">
    {{
      bulkAddAssignee?.error
        ? bulkAddAssignee?.error.message
        : bulkAddAssignee?.message
    }}

    <div id="results-container">
      @if (bulkAddAssignee?.assigneesWithPopulationConflict?.length > 0) {
      <div>
        <ng-container
          *ngTemplateOutlet="
            assigneeList;
            context: {
              assignees: bulkAddAssignee?.assigneesWithPopulationConflict,
              title: 'have not been uploaded due to conflicts',
              success: false
            }
          "
        ></ng-container>
      </div>
      } @if (bulkAddAssignee?.assigneesToActionManually?.length > 0) {
      <div>
        <ng-container
          *ngTemplateOutlet="
            assigneeList;
            context: {
              assignees: bulkAddAssignee?.assigneesToActionManually,
              title: 'will need to be actioned manually',
              success: false
            }
          "
        ></ng-container>
      </div>
      } @if (bulkAddAssignee?.csvAssigneesWithMissingAttr?.length > 0) {
      <div>
        <ng-container
          *ngTemplateOutlet="
            assigneeList;
            context: {
              assignees: bulkAddAssignee?.csvAssigneesWithMissingAttr,
              title: 'have not been uploaded due to missing attributes',
              success: false
            }
          "
        ></ng-container>
      </div>
      } @if (bulkAddAssignee?.assigneesAdded?.length > 0) {
      <div>
        <ng-container
          *ngTemplateOutlet="
            assigneeList;
            context: {
              assignees: bulkAddAssignee?.assigneesAdded,
              success: true,
              title: 'have been added'
            }
          "
        ></ng-container>
      </div>
      } @if (bulkAddAssignee?.assigneesUpdated?.length > 0) {
      <div>
        <ng-container
          *ngTemplateOutlet="
            assigneeList;
            context: {
              assignees: bulkAddAssignee?.assigneesUpdated,
              success: true,
              title: 'have been updated'
            }
          "
        ></ng-container>
      </div>
      } @if (bulkAddAssignee?.assigneesLeftAlone?.length > 0) {
      <div>
        <ng-container
          *ngTemplateOutlet="
            assigneeList;
            context: {
              assignees: bulkAddAssignee?.assigneesLeftAlone,
              success: true,
              title: 'have been left alone'
            }
          "
        ></ng-container>
      </div>
      } @if (bulkAddAssignee?.assigneesMovedPop?.length > 0) {
      <div>
        <ng-container
          *ngTemplateOutlet="
            assigneeList;
            context: {
              assignees: bulkAddAssignee?.assigneesMovedPop,
              title: 'have moved populations',
              success: true,
              movedPop: true
            }
          "
        ></ng-container>
      </div>
      } @if (bulkAddAssignee?.newTaxReturns?.length > 0) {
      <div>
        <ng-container
          *ngTemplateOutlet="
            assigneeList;
            context: {
              assignees: bulkAddAssignee?.newTaxReturns,
              success: true,
              title: 'had {{taxReturnAlias}} created'
            }
          "
        ></ng-container>
      </div>
      } @if (bulkAddAssignee?.updatedTaxReturns?.length > 0) {
      <div>
        <ng-container
          *ngTemplateOutlet="
            assigneeList;
            context: {
              assignees: bulkAddAssignee?.updatedTaxReturns,
              success: true,
              title: 'had {{taxReturnAlias}} updated'
            }
          "
        ></ng-container>
      </div>
      } @if (bulkAddAssignee?.assigneesClientNotFound?.length > 0) {
      <div>
        <ng-container
          *ngTemplateOutlet="
            assigneeList;
            context: {
              assignees: bulkAddAssignee?.assigneesClientNotFound,
              title:
                'for whom {{taxReturnAlias}} cannot be created due to client name cannot be found',
              success: false
            }
          "
        ></ng-container>
      </div>
      } @if (bulkAddAssignee?.assigneesPopulationNotFound?.length > 0) {
      <div>
        <ng-container
          *ngTemplateOutlet="
            assigneeList;
            context: {
              assignees: bulkAddAssignee?.assigneesPopulationNotFound,
              title:
                'have been added to Unassigned population due to population name cannot be found',
              success: true
            }
          "
        ></ng-container>
      </div>
      }
    </div>
  </div>

  <div class="actions">
    <div class="ui primary background button approve">OK</div>
  </div>
</div>

<ng-template
  #assigneeList
  let-assignees="assignees"
  let-title="title"
  let-success="success"
  let-movedPop="movedPop"
>
  <div class="ui accordion">
    <div class="title" [ngClass]="{ success: success, fail: !success }">
      <h4>
        <span class="ui label"
          >{{ assignees?.length }}
          {{ assignees.length > 1 ? "assignees" : "assignee" }}</span
        >
        {{ title }}
      </h4>
      <i class="chevron down icon"></i>
    </div>

    <div class="content">
      <table class="ui basic compact table">
        <thead>
          <tr>
            <th>{{ entityPrimaryName }}</th>
            <th>{{ entitySecondaryName }}</th>
            <th>{{ atlasIdVariable }}</th>
            <th>{{ "clients.tax-id" | transloco }}</th>
            @if (movedPop) {
            <th>{{ "clients.new-population-name" | transloco }}</th>
            }
          </tr>
        </thead>
        <tbody>
          @for (assignee of assignees; track assignee) {
          <tr>
            <td style="width:1px;padding-right: 5rem">
              {{ assignee?.firstName }}
            </td>
            <td>{{ assignee?.lastName }}</td>
            <td>{{ assignee?.atlasId }}</td>
            <td>{{ assignee?.taxId }}</td>
            @if (movedPop) {
            <td>{{ (assignee?.populations)[0]?.name }}</td>
            }
          </tr>
          }
        </tbody>
      </table>
    </div>
  </div>
</ng-template>
